module.exports = __webpack_public_path__ + "static/media/footer-phone.fbaaa333.svg";